import { createSlice } from "@reduxjs/toolkit";

const UserSlice = createSlice({
    name: "User",
    initialState: {
        user_name: null,
        user_id: null,
        access_token: null,
        email: null
    },
    reducers: {
        login: (state, action) => {
            return { ...action.payload }
        },
        updateUser: (state, action) => {
            return { ...state, ...action.payload }
        },
        logout: (state) => {
            return {
                user_name: null,
                user_id: null,
                access_token: null,
                email: null
            }
        }
    }
})

export const { login, updateUser, logout } = UserSlice.actions;

export default UserSlice.reducer;